<template>
  <div id="customPrint" class="" :style="{'height':screenH+'px'}">
    <div class="layer-wrapper" v-if="isShowInviteTip"></div>
    <div class="y-p-r y-mt-8">
      <el-tabs v-model="activeName" class="data-tabs" type="border-card" :style="{'min-height':screenH - 20 +'px'}" @tab-click="handleClick">
        <el-tab-pane name="ADD_ORDER" label="新建订单">
          <addPrintOrder ref="addOrders" v-if="activeName == 'ADD_ORDER'" :rowInfo="rowInfo" :bindUserInfo="bindUserInfo" :bindSellerInfo="bindSellerInfo" @goApplyOrder="goApplyOrderFn" @geToRecharge="geToRecharge" @openSaveAccount="openSaveAccount" @hasActiveAuth="hasActiveAuth" @goToRealName="goToRealName"></addPrintOrder>
        </el-tab-pane>
        <el-tab-pane label="批量导入" name="EXPORT_ORDER">
          <exportOrder ref="EXPORT_ORDER" v-if="activeName == 'EXPORT_ORDER'" curComponent="EXPORT_ORDER" :bindSellerInfo="bindSellerInfo" @goApplyOrder="goApplyOrderFn"></exportOrder>
        </el-tab-pane>
        <el-tab-pane label="待打印" name="APPLY_ORDER">
          <printintList ref="APPLY_ORDER" v-if="activeName == 'APPLY_ORDER'" curComponent="APPLY_ORDER" @copyOrder="copyOrderFn" @getPrintData="goApplyOrderFn"
            :savePrintData="savePrintData"></printintList>
        </el-tab-pane>
        <el-tab-pane label="已打印" name="PRINTED_ORDER">
          <printintList ref="PRINTED_ORDER" v-if="activeName == 'PRINTED_ORDER'" curComponent="PRINTED_ORDER" @copyOrder="copyOrderFn"></printintList>
        </el-tab-pane>
        <el-tab-pane label="全部订单" name="ALL_ORDER">
          <printintList ref="ALL_ORDER" v-if="activeName == 'ALL_ORDER'" curComponent="ALL_ORDER" @copyOrder="copyOrderFn"></printintList>
        </el-tab-pane>
        <!-- <el-tab-pane label="邀请消费者下单" name="INVITE_ORDER">
          <inviteCustomersOrders ref="INVITE_ORDER" v-if="activeName == 'INVITE_ORDER'" curComponent="INVITE_ORDER" @openPreAilDialog="openPreAilDialog" @copyOrder="copyOrderFn" @openSaveAccount="openSaveAccount" @goToRealName="goToRealName"></inviteCustomersOrders>
        </el-tab-pane> -->
      </el-tabs>
      <div class="y-p-a right-btn y-f y-f-a y-f-je">
        <span class="merchant-box y-c-p y-mr-20" @click="viewBindSellerFn" v-if="bindSellerInfo && bindSellerInfo.name">
          已绑定：<span class="merchant-code systemColor">{{ bindSellerInfo.name }}</span> 为专属业务员
        </span>
        <span class="merchant-box y-c-p y-mr-20 systemColor" @click="bindSellerFn" v-else>
          绑定专属业务员
        </span>
        <!-- <img src="@/assets/images/icon/btn_YXWD_bindUser@2x.png" class="acitivityIcon" @click="showActivityDialog = true" v-if="activeFlag&&(bindUserInfo.bindOrgCode || bindUserInfo.bindEmployeeCode)" />
        <img src="@/assets/images/icon/btn_YXWD@2x.png" class="acitivityIcon" @click="showActivityDialog = true" v-else-if="activeFlag&&!bindUserInfo.bindOrgCode&&!bindUserInfo.bindEmployeeCode"/> -->
        <!-- 邀请下单 -->
        <!-- <el-button type="primary" class="invteBtn y-mr-10" @click="showInitDialogFn">邀请消费者自助下单</el-button> -->
        <!-- <el-popover
          popper-class="invite-propver"
          placement="left"
          width="220"
          :visible-arrow="true"
          trigger="manual"
          v-model="isShowInviteTip">
          <div class="">
            <div class="y-f y-f-a y-f-jb y-fc-fff y-fs-14">
              <div>新功能引导: 邀请自助下单</div>
              <i class="el-icon-close close-invite y-c-p" @click="knownFn('close')"></i>
            </div>
            <div class="y-mt-10 y-fs-12 y-fc-fff">逆向退货支持分享二维码，邀请消费者微信扫码自助下单了。</div>
            <div class="y-f y-f-je y-mt-30">
              <div class="knowBtn" @click="knownFn('remember')">知道了</div>
            </div>
          </div>
        </el-popover> -->
        <!-- <el-button class="border-btn header-btn" type="button" @click="geToRecharge">去充值</el-button> -->
        <el-button class="border-btn header-btn" type="button" @click="freightRateInquiryFn">运费报价</el-button>
        <!-- <i v-if="activeName == 'ADD_ORDER'" class="el-icon-question y-ml-10 y-va-m y-fc-systemcolor" @click="showHelpFn"></i> -->
        <!-- <el-button  v-if="activeName == 'APPLY_ORDER'" class="header-btn"  type="text" @click="goToRechargebill">逆向退货账单</el-button> -->
      </div>
    </div>
    <!-- <goToRecharge :stateData="stateData" :auth_code="auth_code"  v-if="goToRechargeFlag" :visible.sync="goToRechargeFlag" ref="goToRechargeRef" @loaded="loaded"/> -->
    <freightRateInquiry  v-if="freightRateInquiryFlag" :visible.sync="freightRateInquiryFlag"/>     
    <rechareCardHelp  v-if="rechareCardHelpFlag" :visible.sync="rechareCardHelpFlag"/>      

    <!-- 下单协议 -->
    <privacy
      v-if="isShowPrivacyDialog"
      :isShow="isShowPrivacyDialog"
      :isCheckedPrivacy="false"
      @close="closePrivacyDialog"
    ></privacy>

    <!-- 邀请自助下单弹层 -->
    <inviteSetting
      v-if="showInviteSettingDialog"
      :isShow="showInviteSettingDialog"
      @closeDialog="closeInviteSettingDialog"
    ></inviteSetting>
    <!-- 授权支付宝 -->
    <save-account :value="collecAccountDialog" v-if="collecAccountDialog" :data="collecAccountData"
      @close="closeCollecAccount" ref="setCollecAccount" from='returnPickupPrint'></save-account>
    <!-- 支付宝已授权请填写支付宝账号对应的姓名 -->
    <real-name :value="realNameDialog" v-if="realNameDialog" :data="realNameInfo" @close="closeRealName"
      ref="realName" :id="accountInfo.id||''"></real-name>
    <!-- 修改订单弹层 -->
    <preAlipayAndRealNameDialog
      @openRealNameDialog="openRealNameDialog"
      @goOpenAliDialog="goOpenAliDialog"
      :realNameId="realNameId"
      v-if="preAlipayAndRealNameFlag"
      :isShow="preAlipayAndRealNameFlag"
      @closeDialog="closePreAlipayAndRealName"
      @openSaveAccount="openSaveAccount"
      ref="preAlipayAndRealName"
    ></preAlipayAndRealNameDialog>   
    <!-- 实名认证 -->
    <AuthRealName :showAuthRealNameDialog.sync="showAuthRealNameDialog" :showType="showType" :certInfo="certInfo"
      @update="closeAuthRealNameAndUpdate"   />  

    <!-- 营销活动弹层 -->
    <activitySetting
      v-if="showActivityDialog"
      :isShow="showActivityDialog"
      :bindUser="bindUserInfo"
      @closeDialog="closeActivityDialog"
    ></activitySetting>

    <!-- 绑定业务员弹层 -->
    <bindSellerInfo
      v-if="showBindSellerDialog"
      :isShow="showBindSellerDialog"
      :bindUser="bindSellerInfo"
      :bindType="bindType"
      operateType="SELLER"
      @closeDialog="closeBindSellerDialog"
    ></bindSellerInfo>
  </div>
</template>

<script>
import inviteCustomersOrders from './components/inviteCustomersOrders';
import printintList from './printingTable';
import addPrintOrder from './components/OrderInfo';
import exportOrder from './components/exportOrder';
import { queryListByTypeApi, insertConfirmRecordApi, searchBindUserInfoApi } from '@/api/waybillPrint/returnPickupPrint';
import { isRealNameApi, getCertInfoApi } from '@/api/systemModule/accountSetting/info'
import { searchSellerBindInfoApi } from '@/api/waybillPrint/OzonOrderPrint';
export default {
  name: 'printingPage',
  components: {
    inviteCustomersOrders,//邀请消费者者下单
    printintList, // A 网面单
    addPrintOrder,
    exportOrder,
    goToRecharge: () => import('./components/goToRecharge.vue'),
    freightRateInquiry:()=>import('./components/freightRateInquiry.vue'),
    rechareCardHelp:()=>import('./components/rechareCardHelp.vue'),
    inviteSetting: ()=> import ('./components/inviteSettingDialog'),
    privacy: () =>import ('./components/privacy'),
    saveAccount: () => import('./components/setCollectAccountByQuick/saveAccount.vue'),// 授权支付宝  
    preAlipayAndRealNameDialog: () => import('./components/preAlipayAndRealNameDialog.vue'),
    AuthRealName:()=> import('@/views/systemModule/accountSetting/components/authRealName.vue'),
    realName: () => import('./components/setCollectAccountByQuick/realName.vue'),// 支付宝已授权请填写支付宝账号对应的姓名  
    activitySetting: ()=> import ('./components/activitySetting'),
    bindSellerInfo: () => import('../ozonPrint/components/bindSellerInfo.vue'),
  },
  data() {
    return {
      activeFlag:false,
      certInfo: {
          "loginId": "",
          "cerNo": "",
          "cerName": "",
          "cerType": null,
          "cerTypeName": ""
      }, //实名认证信息      
      showType: '',//实名认证状态add、edit
      showAuthRealNameDialog: false,
      realNameId:'',
      preAlipayAndRealNameFlag: false,
      collecAccountDialog: false, // 设置理赔账户
      collecAccountData: {},
      accountInfo:{},//授权账号信息
      
      realNameDialog: false, // 设置支付宝真实姓名
      realNameInfo: {},

      auth_code: '',
      rechareCardHelpFlag: false,
      stateData:'',
      freightRateInquiryFlag: false,  
      goToRechargeFlag: false,         
      activeName: 'ADD_ORDER',
      screenH:(document.body.clientHeight) - 73,
      rowInfo: {},
      hasMobile: true,

      isShowInviteTip: false, // 帮助指引提示弹层
      isShowPrivacyDialog: false, // 隐私协议弹层
      showInviteSettingDialog: false, // 邀请下单配置弹层
      showActivityDialog: false, // 绑定营销网点弹层
      bindUserInfo: {}, // 绑定的业务员或网点信息
      savePrintData: null, // 保存打印数据

      bindSellerInfo: {}, // 绑定的业务员信息
      showBindSellerDialog: false, // 绑定业务员弹层
      bindType: '', // 绑定类型
    };
  },
  computed: {
    userMess() {
      return this.$store.state.user;
    },
  },
  methods: {
    goToRealName(){
      this.showType = 'add';
      this.showAuthRealNameDialog = true;
    },
    closeAuthRealNameAndUpdate() {
      //TODO实名完成后刷新实名信息
      this.getIsRealName();
    },
    getIsRealName() {
        isRealNameApi().then(res => {
            if (res.data.status == 1 && res.data.data == true) {
                setTimeout(() => {
                  this.realNameId = 'true'
                  this.$refs.preAlipayAndRealName.initData(res.data.realNameId,'getCertInfo');

                }, 500) 
            } else {
                setTimeout(() => {
                  this.$refs.preAlipayAndRealName.initData('','getCertInfo');

                }, 500) 
            }
        }).catch(() => {
            setTimeout(() => {
              this.$refs.preAlipayAndRealName.initData('','getCertInfo');

            }, 500) 
        }).finally(() => {

        })
    },    
    hasActiveAuth(activeFlag){
      this.activeFlag = activeFlag
    },
    openRealNameDialog(certInfo){
      if(certInfo&&certInfo.cerNo){
        this.certInfo = certInfo;
        this.showType = 'edit';
      }else{
        this.showType = 'add';
      }
      this.showAuthRealNameDialog = true;
    },
    goOpenAliDialog(){
      this.collecAccountDialog = true;
    },
    openPreAilDialog(realNameId){
      console.log("openPreAilDialog",realNameId);
      // this.realNameId = realNameId;
      this.preAlipayAndRealNameFlag = true;
      this.getIsRealName();

    },
    closePreAlipayAndRealName(){
      this.preAlipayAndRealNameFlag = false;
    },
    // 打开支付宝真实姓名弹层
    openRealName() {
      this.realNameInfo = JSON.parse(JSON.stringify(this.$route.query));
      this.$set(this.realNameInfo,'realNameId',this.realNameId)
      console.log("operealNameInfonRealName",this.realNameInfo);
      this.realNameDialog = true;
    },    
    openSaveAccount(realNameId){
      console.log("openSaveAccount",realNameId);
      this.openPreAilDialog(realNameId)
    },
    closeRealName(recheckAlipay) {
      if(recheckAlipay){
        //TODO重新查看支付宝绑定信息
        try{
          this.$refs.addOrders.UpDateAlyName(recheckAlipay);
        }catch(e){
          this.$refs.INVITE_ORDER.UpDateAlyName(recheckAlipay);
        }
        
      }
      this.realNameDialog = false;
      // this.realNameData = {};
    },    
    // 关闭设置理赔账户窗口
    closeCollecAccount() {
      this.collecAccountDialog = false;
    },    
    goToRechargebill(){
      this.$router.push({
        name: 'specialReturnandPickupBill',
      });
    },
    showHelpFn(){
      this.rechareCardHelpFlag = true;
    },
    loaded(){
      if(this.$route.query && this.$route.query.app_id&& this.$route.query.auth_code&&this.$route.query.source=='alipay_wallet'&&this.$route.query.state){ 
        if(this.$route.query.state=='returnPickupPrint'){

        }else{
          this.stateData =this.$route.query.state
          this.auth_code = this.$route.query.auth_code
          this.$nextTick(()=>{
            this.$refs.goToRechargeRef.getAlipayAuthUserIdFn(this.$route.query.state,this.$route.query.auth_code)
          })
        }

      }  
    },
    freightRateInquiryFn(){
      this.freightRateInquiryFlag = true;
    },
    geToRecharge(){
      this.goToRechargeFlag = true;
    },      
    copyOrderFn(row) {
      this.rowInfo = row;
      this.activeName = 'ADD_ORDER';
    },
    goApplyOrderFn(row) {
      if (this.activeName == 'ADD_ORDER' || this.activeName == 'EXPORT_ORDER') {
        this.activeName = 'APPLY_ORDER';
      }
      this.savePrintData = row;
    },
    handleClick(tab){
      this.rowInfo = {};
    },
    showInitDialogFn() {
      // 接口查询 是否要显示指引
      queryListByTypeApi({pactType: 'returnPickupPrint'}).then(res => {
        if (res.status == 200 && res.data.length) {
          let list = res.data.filter(t => { return t.pactType == 'returnPickupPrint'; });
          if (list.length) {
            // 已记住指引,直接判断是否记住隐私协议
            this.knownFn('');
          } else {
            this.isShowInviteTip = true;
          }
        } else {
          this.isShowInviteTip = true;
        }
      }).catch(()=>{
        this.isShowInviteTip = true;
      })
    },
    closeInviteSettingDialog() { 
      this.showInviteSettingDialog = false;
    },
    closeActivityDialog(refresh) {
      this.showActivityDialog = false;
      if (refresh == 'refresh') {
        this.getBindUserInfo();
      }
    },
    knownFn(type) {
      if (type == 'close') {
        this.isShowInviteTip = false;
        return false;
      }
      if (type == 'remember') {
        // 保存记忆
        insertConfirmRecordApi({pactType: 'returnPickupPrint'});
      }
      this.isShowInviteTip = false;

      // 查询是否需要已阅读隐私协议
      queryListByTypeApi({pactType: 'returnPickupPrivacy'}).then(res => {
        if (res.status == 200 && res.data.length) {
          let list = res.data.filter(t => { return t.pactType == 'returnPickupPrivacy'; });
          if (list.length) {
            // 已阅读隐私协议
            this.isShowPrivacyDialog = false;
            // 点了邀请自助下单后，若已同意协议，这里要打开 邀请配置弹框
            this.showInviteSettingDialog = true;
          } else {
            this.isShowPrivacyDialog = true;
          }
        } else {
          this.isShowPrivacyDialog = true;
        }
      }).catch(()=>{
        this.isShowPrivacyDialog = true;
      });
    },
    closePrivacyDialog(isChecked) {
      this.isShowPrivacyDialog = false; 
      if (isChecked) {
        this.showInviteSettingDialog = true;
        if (this.$refs.addOrders) {
          // 保存完成之后再调用接口查询一次
          this.$refs.addOrders.isShowPrivacy = true;
        }
      }
    },
    getBindUserInfo() {
      this.bindUserInfo = {};
      searchBindUserInfoApi({bindType: 'SELLER'}).then(res => {
        if (res.message == 'ok') {
          this.bindUserInfo = res.data;
        }
      });
    },
    getBindSellerInfo() {
      this.bindSellerInfo = {};
      searchSellerBindInfoApi({bindType: 'SELLER'}).then(res => {
        if (res.message == 'ok') {
          this.bindSellerInfo = res.data || {};
        }
      });
    },
    viewBindSellerFn() {
      this.bindType = 'view';
      this.showBindSellerDialog = true;
    },
    bindSellerFn() {
      this.bindType = 'bind';
      this.showBindSellerDialog = true;
    },
    closeBindSellerDialog(refresh) {
      this.bindType = '';
      this.showBindSellerDialog = false;
      if (refresh) {
        this.getBindSellerInfo();
      }
    },
  },
  created() {
    this.hasMobile = this.userMess.mobile;
    if (!this.hasMobile) {
      this.$confirm('当前账号未绑定手机号，请使用手机号登录后使用该功能！', '提示', {
        confirmButtonText: '确定',
        showClose: false,
        showCancelButton: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        closeOnHashChange: false,
        type: 'warning'
      }).then(() => {
        if (window.history.length > 2) {
          this.$router.go(-1)
        } else {
          this.$router.push('/') // 如果没有历史记录，则跳转到首页
        }
      });
    }
    // 查询绑定的业务员信息
    this.getBindUserInfo();

    // 查询绑定的业务员信息--新
    this.getBindSellerInfo();
  },
  mounted() {
    // document.addEventListener('click', (e) =>{
    //   // 点击页面空白处，关闭邀请下单弹层
    //   let dom = document.querySelector('.invite-propver');
    //   let dom2 = document.querySelector('.invteBtn');
    //   if ((dom && !dom.contains(e.target)) && (dom2 && !dom2.contains(e.target))) {
    //     this.isShowInviteTip = false;
    //   }
    // });
    if(this.$route.query && this.$route.query.app_id&& this.$route.query.auth_code&&this.$route.query.source=='alipay_wallet'&&this.$route.query.state){   
      if(this.$route.query.state=='returnPickupPrint'){
        let flag = false;
        if(localStorage.getItem('returnPickupPrint-realName')){
          flag = true;
        }        
        //打开绑定支付宝弹框    
        this.openRealName();
        if(flag){
          // this.openRealName();
        }    
        
      } else{
        this.geToRecharge();
      }  
      
    }
    if (this.$route.params.openRecharge) {
      this.geToRecharge(); // 打开充值弹窗
    } 
    const type = this.$route.params.type;    //首页跳转过来
    if(type=='recharge'){
      this.geToRecharge();
    }    
  },
  beforeDestroy() {
    this.rowInfo = {};
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.right-btn {
  z-index: 99;
  top: 0px;
  right: 8px;
  .merchant-box {
    font-family: PingFangSC, PingFang SC;
    padding: 6.4px 13px;
    font-size: 13px;
    color: #52585F;
    background: #FFFFFF;
    border-radius: 2px;
    margin-right: 15px;
    .merchant-code {
      font-weight: 600;
      font-size: 13px;
      color: #333333;
    }
    .merchant-btn {
      font-weight: 500;
      font-size: 13px;
      color: #653EB3;
      cursor: pointer;
    }
  }
}
.y-mt-8 {
  margin-top: 8px;
}
.custom-waybill-wrapper {
  background-color: #fff;
}

/deep/ .el-popover.invite-propver {
  top: 0px;
  left: -260px;
  padding: 10px 16px;
  background: #653EB3;
  border-color:#653EB3;
  .knowBtn {
    width: 88px;
    height: 32px;
    line-height: 32px;
    background: #FFFFFF;
    border-radius: 4px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #653EB3;
    text-align: center;
    cursor: pointer;
  }
}
.layer-wrapper {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0,0,0, 0.2);
  z-index: 5
}
.header-btn {
  height: 28px;
  border: 1px solid #fff;
  border-radius: 2px;
  background: #fff;
  padding: 0 10px;
  span {
    display:inline-block;
  }
}
.acitivityIcon {
  display: inline-block;
  width: 190px;
  height: auto;
  cursor: pointer;
  margin-right: 16px;
}
::-webkit-scrollbar {
  width: 2px;
  height: 3px;
}
::-webkit-scrollbar-track {
  border-radius: 2px; /*滚动条的背景区域的圆角*/
}
::-webkit-scrollbar-thumb {
  border-radius: 2px; /*滚动条的圆角*/
  background-color: #ccc; /*滚动条的背景颜色*/
}
 
::-webkit-scrollbar-thumb:hover {
  background-color: #bbb;
}
 
::-webkit-scrollbar-thumb:active {
  cursor: pointer;
}
</style>
